import React from 'react';

const MicrophoneIcon = (props) => (
  <svg width='32' height='32' viewBox='0 0 32 32' {...props}>
    <g fill='currentColor' fillRule='nonzero'>
      <g transform='translate(8.000000, 6.000000)'>
        <path d='M4,0 C6.209139,0 8,1.790861 8,4 L0,4 C0,1.790861 1.790861,0 4,0 M6.84,6.82 L6,15 L5,15 L5,16 C5,17.1045695 5.8954305,18 7,18 C8.1045695,18 9,17.1045695 9,16 L9,11 C9,8.790861 10.790861,7 13,7 L15,7 L14,8 L15,9 L13,9 C11.8954305,9 11,9.8954305 11,11 L11,16 C11,18.209139 9.209139,20 7,20 C4.790861,20 3,18.209139 3,16 L3,15 L2,15 L1.16,6.82 C0.67,6.32 0.31,5.7 0.13,5 L7.87,5 C7.69,5.7 7.33,6.32 6.84,6.82 M4,8 C3.44771525,8 3,8.44771525 3,9 C3,9.55228475 3.44771525,10 4,10 C4.55228475,10 5,9.55228475 5,9 C5,8.44771525 4.55228475,8 4,8 Z' />
      </g>
    </g>
  </svg>
);

export default MicrophoneIcon;
